import { render, staticRenderFns } from "./HoverImage.vue?vue&type=template&id=0c271c43&scoped=true"
import script from "./HoverImage.vue?vue&type=script&lang=js"
export * from "./HoverImage.vue?vue&type=script&lang=js"
import style0 from "./HoverImage.vue?vue&type=style&index=0&id=0c271c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c271c43",
  null
  
)

export default component.exports